<template>
  <div class="v-client-table" :class="$attrs.class" :style="$attrs.style">
    <div v-if="$slots.afterFilter" class="after-filter-wrapper">
      <slot name="afterFilter"></slot>
    </div>
    <VueGoodTable
      :columns="normalizedColumns"
      :rows="data"
      :search-options="searchOptions"
      :pagination-options="paginationOptions"
      :sort-options="sortOptions"
    >
      <template #table-row="props">
        <slot
          v-if="hasSlot(props.column.field)"
          :name="props.column.field"
          :row="props.row"
          :column="props.column"
          :formattedRow="props.formattedRow"
          :index="props.index"
        />
        <span v-else>{{ defaultCell(props) }}</span>
      </template>
    </VueGoodTable>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table-next'

const titleize = value => {
  if (!value) return ''
  const text = value.replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export default {
  name: 'VClientTable',
  components: { VueGoodTable },
  inheritAttrs: false,
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    options: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data () {
    return {
      searchTerm: ''
    }
  },
  computed: {
    normalizedOptions () {
      return Array.isArray(this.options) ? {} : (this.options || {})
    },
    visibleColumns () {
      return Array.isArray(this.normalizedOptions.visibleColumns)
        ? this.normalizedOptions.visibleColumns
        : null
    },
    hideFilters () {
      const classList = this.$attrs.class || ''
      return classList.split(' ').includes('hide-filters')
    },
    headings () {
      return this.normalizedOptions.headings || {}
    },
    sortableColumns () {
      return this.normalizedOptions.sortable || null
    },
    normalizedColumns () {
      const normalized = this.columns.map(column => {
        if (typeof column === 'string') {
          const isSortable = Array.isArray(this.sortableColumns)
            ? this.sortableColumns.includes(column)
            : true
          return {
            field: column,
            label: this.headings[column] || titleize(column),
            sortable: isSortable
          }
        }
        return column
      })
      if (this.visibleColumns && this.visibleColumns.length) {
        return normalized.filter(column => this.visibleColumns.includes(column.field))
      }
      return normalized
    },
    searchOptions () {
      const placeholder = this.normalizedOptions.texts && this.normalizedOptions.texts.filterPlaceholder
        ? this.normalizedOptions.texts.filterPlaceholder
        : 'Search...'
      return {
        enabled: !this.hideFilters,
        externalQuery: this.searchTerm,
        placeholder
      }
    },
    paginationOptions () {
      const perPage = typeof this.normalizedOptions.perPage === 'number'
        ? this.normalizedOptions.perPage
        : 10
      const perPageDropdown = Array.isArray(this.normalizedOptions.perPageDropdown)
        ? this.normalizedOptions.perPageDropdown
        : [10, 20, 30, 40, 50]
      return {
        enabled: true,
        perPage,
        perPageDropdown
      }
    },
    sortOptions () {
      const sortable = this.normalizedOptions.sortable
      return {
        enabled: sortable !== false
      }
    }
  },
  methods: {
    hasSlot (name) {
      return Boolean(name && this.$slots[name])
    },
    defaultCell ({ formattedRow, column }) {
      const value = formattedRow && column && column.field ? formattedRow[column.field] : ''
      return value === null || typeof value === 'undefined' || value === '' ? '-' : value
    },
    setFilter (value) {
      this.searchTerm = value || ''
    }
  }
}
</script>
